import { just } from 'maybeasy';
import * as React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { segmentRoute } from '../../ClientRoutes';
import ProgramStore from '../../ProgramStore';
import { T, TPlainTextKey } from '../../Translations';
import ArrowRightIcon from '../Cutesies/ArrowRightIcon';
import * as style from './style.module.css';

interface Props {
  programStore: ProgramStore;
  classname?: string;
}

const beginOrResumeText = (percentComplete: number): TPlainTextKey =>
  percentComplete === 0 ? 'Begin' : 'Resume';

const BeginOrResumeButton: React.FC<Props> = ({ programStore, classname = '' }) => {
  return just({})
    .assign('currentSegment', programStore.currentSegment)
    .assign('percentComplete', programStore.percentComplete)
    .assign('title', programStore.title)
    .map(({ currentSegment, percentComplete, title }) => {
      const buttonText = beginOrResumeText(percentComplete);
      const ariaLabel = `${buttonText} ${title.text}`;

      return (
        <Link
          to={segmentRoute(currentSegment)}
          className={clsx(style.continueButton, classname)}
          data-test-continue-button={buttonText}
          data-intercom-target={
            percentComplete === 0 ? 'begin-program-button' : 'resume-program-button'
          }
          aria-label={ariaLabel}
        >
          <T kind={buttonText} />
          <div className={style.buttonIcon}>
            <ArrowRightIcon />
          </div>
        </Link>
      );
    })
    .getOrElse(() => <span />);
};

export default BeginOrResumeButton;
